module.exports = __webpack_public_path__ + "img/pdf_parsing.73d0ffc7.png";